import api from "!../../../../../../node_modules/laravel-mix/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-45.use[1]!../../../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../../../node_modules/laravel-mix/node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-45.use[2]!../../../../../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-45.use[3]!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PrepageMainServices.vue?vue&type=style&index=0&id=9a5409ae&prod&scoped=true&lang=scss&";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};